import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Action } from 'src/app/model/gestion/gestion';
import { DialogConfirmServiceService } from 'src/app/services/dialog-confirm-service.service';
import { GestionActionsSavService } from 'src/app/services/http/gestion/gestion-actions-sav.service';

import { DialogOverViewComponent } from 'src/app/components/dialog-over-view/dialog-over-view.component';
import { EditGestionComponent } from '../../edit-gestion/edit-gestion/edit-gestion.component';

@Component({
  selector: 'app-gestion-actions-sav',
  templateUrl: './gestion-actions-sav.component.html',
  styleUrls: ['./gestion-actions-sav.component.scss']
})
export class GestionActionsSavComponent implements OnInit {

  public actionsSavList!: Action[];
  form !: FormGroup;
  /* Display list */
  displayList: boolean = false;
  /* Message by default on display category list button  */
  message: string = "Afficher la liste";

  messageDialog : string = "";
  addMsg : string = "Élément ajouté";
  itemDeletedSuccessMsg : string = "Élément supprimé";
  itemDeletedFailureMsg : string = "Suppresion impossible";


  get displayedColumn(): string[] {
    const result: string[] = ['nom', 'edit', 'delete'];
    return result;
  }

  newActionSav: Action = {
    action_name: "",
  };


  constructor(private service: GestionActionsSavService, private builder: FormBuilder, private dialog: MatDialog, private confirmDialog: DialogConfirmServiceService) { }

  ngOnInit() {
    this.loadList();
    this.buildForm();
  }


  buildForm() {

    this.form = this.builder.group({
      nom: ['', Validators.required],
    })
  }


  /* GET the list of actions sav */
  public loadList() {
    this.service.getActionsSavList().subscribe(list => {
      this.actionsSavList = list;

       /* Only display type actions with deleted field equal to false. */
     this.actionsSavList =  this.actionsSavList.filter( function (el) {
      return el.deleted == false;
    })

      return this.actionsSavList;
    })
  }

  public onClickVoirListe() {
    this.displayList = !this.displayList;
    if (!this.displayList) {
      this.message = "Afficher la liste";
    } else {
      this.message = "Masquer la liste";
    }

  }

  public onSubmit() {
    this.onCreate();
  }

  public onCreate() {

      this.newActionSav.action_name = this.form.value.nom;
      this.service.postActionSav(this.newActionSav).subscribe((data) => {
        this.messageDialog = this.addMsg;
        this.loadList();
        this.openMessageDialog();
      }, (err) => {
        console.log('ERROR', err);
      })

  }

  public onEdit(action: Action) {
    const dialogRef = this.dialog.open(EditGestionComponent, {
      data: {
        id: action.action_id,
        inputs: ['nom'],
        value: [action.action_name],
        form: this.form
      }
    });

    dialogRef.afterClosed().subscribe(
      res => {
        if (res != null) {
          let updateCategory: Action = { action_name: "" };
          updateCategory.action_name = res.values[0];
          updateCategory.action_id = res.values[1];

          this.service.editActionSav(res.id, updateCategory).subscribe((data) => {
            this.loadList();
          }, (err) => {
            console.log('ERROR', err);
          })

        } 
      }
    )
  }

  public onDelete(id : number, action: Action) {
    console.log(action);
    this.confirmDialog.openConfirmDialog("Voulez-vous supprimer cet élément ?").afterClosed()
    .subscribe(res => {

      if (res) {
        this.service.deleteActionSav(id, action).subscribe((data) => {
          this.messageDialog = this.itemDeletedSuccessMsg;
          this.loadList();
          this.openMessageDialog();
        }, (err) => {
          console.log('ERROR', err);
          this.messageDialog = this.itemDeletedFailureMsg;
          this.openMessageDialog();
        })

      }

    });

  }


   /* Alert user when new item is created  */
   public openMessageDialog(): any {
    this.dialog.open(DialogOverViewComponent, {
      width: '20%',
      data: { message: this.messageDialog }
    });
  }
}
